import { createContext } from 'react';
var AccordionContext = /*#__PURE__*/createContext({
  toggleContent: function toggleContent() {},
  expanded: false,
  id: ''
});
export default AccordionContext;